/**
 * Metrics Feature Component
 * Handles tabs, zone selection, and session progress tracking.
 */

export function MetricsComponent(config = {}) {
    return {
        activeTab: config.initialTab || 'dashboard',
        captureMode: 'quick',
        activeZone: 'all',
        dirtyMetrics: {},

        init() {
            window.addEventListener('metric-changed', (e) => {
                this.dirtyMetrics[e.detail.name] = true;
            });
        },

        get dirtyCount() {
            return Object.keys(this.dirtyMetrics).length;
        },

        get progressPercent() {
            return Math.min(100, (this.dirtyCount / 16) * 100);
        },

        setTab(tab) {
            this.activeTab = tab;
        },

        setCaptureMode(mode) {
            this.captureMode = mode;
        },

        setZone(zone) {
            this.activeZone = zone;
        },
    };
}
